import { render, staticRenderFns } from "./AccountRegisterSuccess.vue?vue&type=template&id=b1a33108&scoped=true&"
import script from "./AccountRegisterSuccess.vue?vue&type=script&lang=js&"
export * from "./AccountRegisterSuccess.vue?vue&type=script&lang=js&"
import style0 from "./AccountRegisterSuccess.vue?vue&type=style&index=0&id=b1a33108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a33108",
  null
  
)

export default component.exports